import React from 'react';
import Header from './components/Header';
import './SignUpPage.css';
import { SignUp } from '@clerk/react';

function SignUpPage() {
  return (
    <>
      <Header />
      <div className="dashboard-container">
        <div className="dashboard-placeholder">
          <SignUp
            // send new sign-ups straight to Stripe checkout (Clerk Billing PricingTable)
            forceRedirectUrl="/checkout"
            fallbackRedirectUrl="/checkout"
          />
        </div>
      </div>
    </>
  );
}

export default SignUpPage;
